import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "field has-addons" }
const _hoisted_2 = { class: "control" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = { class: "control" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "icon-edit" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  class: "is-flex"
}
const _hoisted_9 = ["title"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "icon-edit has-text-info" }, null, -1)
const _hoisted_11 = [
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.editing && _ctx.enabled)
    ? (_openBlock(), _createElementBlock("form", {
        key: 0,
        onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("p", _hoisted_2, [
            _withDirectives(_createElementVNode("input", {
              class: "input",
              type: "text",
              placeholder: "Name",
              disabled: _ctx.loading || undefined,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event))
            }, null, 8, _hoisted_3), [
              [_vModelText, _ctx.name]
            ])
          ]),
          _createElementVNode("p", _hoisted_4, [
            _createElementVNode("button", {
              class: _normalizeClass(["button is-primary", { 'is-loading': _ctx.loading }]),
              type: "submit",
              disabled: _ctx.loading || undefined
            }, _hoisted_7, 10, _hoisted_5)
          ])
        ])
      ], 32))
    : (_openBlock(), _createElementBlock("div", _hoisted_8, [
        _createElementVNode("span", {
          title: _ctx.instance.name
        }, _toDisplayString(_ctx.truncateLong(_ctx.instance.name)), 9, _hoisted_9),
        (_ctx.enabled)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.editing = true))
            }, _hoisted_11))
          : _createCommentVNode("", true)
      ]))
}